import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { FertilityTreatmentsProvider } from "./FertilityTreatmentsContext";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

import { FertilityTreatmentsTypesScreen } from "./FertilityTreatmentsTypesScreen/FertilityTreatmentsTypesScreen";
import { FertilityTreatmentsCompleteScreen } from "./FertilityTreatmentsCompleteScreen/FertilityTreatmentsCompleteScreen";
import { IUITreatmentsScreen } from "./IUITreatmentsScreen/IUITreatmentsScreen";
import { IVFTreatmentsScreen } from "./IVFTreatmentsScreen/IVFTreatmentsScreen";
import { MedsOnlyTreatmentsScreen } from "./MedsOnlyTreatmentsScreen/MedsOnlyTreatmentsScreen";
import { OITreatmentsScreen } from "./MedsOnlyTreatmentsScreen/OITreatmentsScreen";
import { OtherTreatmentsScreen } from "./OtherTreatmentsScreen/OtherTreatmentsScreen";
import { TimedIntercourseTreatmentsScreen } from "./OtherTreatmentsScreen/TimedIntercourseTreatmentsScreen";
import { UnknownTreatmentsScreen } from "./OtherTreatmentsScreen/UnknownTreatmentsScreen";
import { FETTreatmentsScreen } from "./FETTreatmentsScreen/FETTreatmentsScreen";
import { EggFreezingScreen } from "./EggFreezingScreen/EggFreezingScreen";
import { EmbryoFreezingScreen } from "./EmbryoFreezingScreen/EmbryoFreezingScreen";

export type FertilityTreatmentsStackParamList = {
  FertilityTreatmentsTypes: undefined;
  IUITreatments: undefined;
  IVFTreatments: undefined;
  MedsOnlyTreatments: undefined;
  OITreatments: undefined;
  TimedIntercourseTreatments: undefined;
  OtherTreatments: undefined;
  UnknownTreatments: undefined;
  FETTreatments: undefined;
  EggFreezing: undefined;
  EmbryoFreezing: undefined;
  FertilityTreatmentsComplete: undefined;
};

export type FertilityTreatmentsStackScreenProps<
  T extends keyof FertilityTreatmentsStackParamList,
> = StackScreenProps<FertilityTreatmentsStackParamList, T>;

const Stack = createNativeStackNavigator<FertilityTreatmentsStackParamList>();

export function FertilityTreatmentsNavigator() {
  return (
    <FertilityTreatmentsProvider>
      <MedicalHistoryQuestionProvider
        section="fertility-treatments"
        sectionLabelKey="med_history.review.section_title.fertility-treatments"
        helpTextKey="med_history.question_screen.flow_help.fertility-treatments"
      >
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen
            name="FertilityTreatmentsTypes"
            component={FertilityTreatmentsTypesScreen}
          />
          <Stack.Screen name="IUITreatments" component={IUITreatmentsScreen} />
          <Stack.Screen name="IVFTreatments" component={IVFTreatmentsScreen} />
          <Stack.Screen
            name="MedsOnlyTreatments"
            component={MedsOnlyTreatmentsScreen}
          />
          <Stack.Screen name="OITreatments" component={OITreatmentsScreen} />
          <Stack.Screen
            name="OtherTreatments"
            component={OtherTreatmentsScreen}
          />
          <Stack.Screen
            name="TimedIntercourseTreatments"
            component={TimedIntercourseTreatmentsScreen}
          />
          <Stack.Screen
            name="UnknownTreatments"
            component={UnknownTreatmentsScreen}
          />
          <Stack.Screen name="FETTreatments" component={FETTreatmentsScreen} />
          <Stack.Screen name="EggFreezing" component={EggFreezingScreen} />
          <Stack.Screen
            name="EmbryoFreezing"
            component={EmbryoFreezingScreen}
          />
          <Stack.Screen
            name="FertilityTreatmentsComplete"
            component={FertilityTreatmentsCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </FertilityTreatmentsProvider>
  );
}
